import { useState, useRef, useEffect } from "react";
import classes from "./customDropdown.module.css";

export const CustomDropdown = ({
  id,
  label,
  options = [],
  selectedId = "",
  onSelection,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (!dropdownRef.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  const handleSelect = (option) => {
    onSelection?.(id, option.id);
    setOpen(false);
  };

  const selectedOption = options.find((o) => o.id === selectedId);

  return (
    <div className={classes.wrapper} ref={dropdownRef}>
      <div
        className={`${classes.dropdownBox} ${disabled ? classes.disabled : ""}`}
        onClick={() => !disabled && setOpen((p) => !p)}
      >
        <div className={classes.displayText}>
          {selectedOption?.label || ""}
        </div>

        <label
          className={`${classes.floatingLabel} ${
            selectedId !== "" || open ? classes.labelActive : ""
          }`}
        >
          {label}
        </label>

        <span className={classes.arrow}>{open ? "▲" : "▼"}</span>
      </div>

      {open && !disabled && (
        <ul className={classes.optionsList}>
          {options.map((option) => (
            <li
              key={option.id}
              className={`${classes.option} ${
                option.id === selectedId ? classes.selectedOption : ""
              }`}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
